import React from 'react';
import PropTypes from 'prop-types';
import { CircleSpinner } from '../../../assets/svg';

const SSCToggle = ({
    checked = false,
    title = '',
    onChange = () => {},
    className = '',
    isLoading = false,
    disabled = false,
    ...props
}) => {
    const handleChange = (event) => {
        onChange(event.target.checked, event); // Pass the new state and event object
    };
    return (
        <label className={`switch ${className}`} title={title} {...props} onClick={props?.onClick}>
            {isLoading ? (
                <CircleSpinner size='3rem' />
            ) : (
                <>
                    <input
                        type='checkbox'
                        checked={Boolean(checked)}
                        onChange={handleChange}
                        aria-label={title || 'Toggle'}
                        disabled={Boolean(disabled)}
                    />
                    <span disabled={Boolean(disabled)} className='slider round'></span>
                </>
            )}
        </label>
    );
};

SSCToggle.propTypes = {
    checked: PropTypes.bool,
    title: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onClick: PropTypes.func,
    className: PropTypes.string,
};

export default SSCToggle;
